export default function GeneratorMixpanelService(MixpanelService, $state) {
  return { trackBuilder };

  function trackBuilder() {
    const BUILDER_EVENTS = {
      websiteVisit: 'New Native Display Demo',
      // Now called "Native Outstream"
      instantPlayCard: 'New Native Video Demo',
      // Now called "Standard Outstream"
      outstream: 'New Outstream Demo',
      scroller: 'New Scroller Demo',
      slideshow: 'New Thumbnail Carousel Demo'
    };

    const evt = BUILDER_EVENTS[$state.params.id];

    if (evt) {
      return MixpanelService.track(evt);
    }

    return MixpanelService.track('Editing Saved Demo', {
      demoId: $state.params.id
    });
  }
}

GeneratorMixpanelService.$inject = ['MixpanelService', '$state'];
